// 환자 자동관리 통합 화면 섹션 머리 (2026-10-07) — ▾/▸ 토글(button aria-expanded) + 제목(h2 16px) + 건수(12px 텍스트) + 우측 보조문(12.5px)
// 색만으로 구분하는 요소 없음. 접힘 상태 저장은 부모(ClinicPatients)가 localStorage 로 관리한다.
import React from 'react';

function CollapsibleSection({ id, title, count, hint, open, onToggle, children }) {
    return (
        <section id={id} style={{ marginBottom: 18 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '6px 2px 8px', flexWrap: 'wrap' }}>
                <button type="button" aria-expanded={open} aria-controls={`${id}-body`} onClick={onToggle} title={open ? '접기' : '펼치기'}
                    style={{ width: 22, height: 22, borderRadius: 4, border: '1px solid #cbd5e1', background: '#fff', color: '#64748b', fontSize: 12, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', padding: 0 }}>
                    {open ? '▾' : '▸'}
                </button>
                <h2 style={{ fontSize: 16, fontWeight: 700, color: '#0f172a', margin: 0, cursor: 'pointer' }} onClick={onToggle}>{title}</h2>
                {count != null && <span style={{ fontSize: 12, color: '#94a3b8' }}>{count}</span>}
                {hint && <span style={{ fontSize: 12.5, color: '#64748b', marginLeft: 'auto' }}>{hint}</span>}
            </div>
            {open && <div id={`${id}-body`}>{children}</div>}
        </section>
    );
}

export default CollapsibleSection;
